// extracted by mini-css-extract-plugin
export default {"overlay":"Zw-z","bodyOpen":"_w-z","content":"ax-z","header":"bx-z","close":"cx-z","closeNoHeading":"dx-z"};